import { createSlice } from '@reduxjs/toolkit';
import initialState from './initialState';
import { changePassword } from './services';

export const ChangePasswordModalSlice = createSlice({
  name: 'ChangePasswordModal',
  initialState,
  reducers: {
    openChangePasswordModal(state, action) {
      const { userId, fullName, isOwnPassword } = action.payload;
      return {
        ...initialState,
        isOpen: true,
        userId,
        fullName: fullName ?? '',
        isOwnPassword: Boolean(isOwnPassword),
      };
    },
    closeChangePasswordModal() {
      return { ...initialState };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(changePassword.pending, (state) => {
        state.saveStatus = 'loading';
      })
      .addCase(changePassword.fulfilled, () => ({ ...initialState }))
      .addCase(changePassword.rejected, (state) => {
        state.saveStatus = 'failed';
      });
  },
});

export const { openChangePasswordModal, closeChangePasswordModal } =
  ChangePasswordModalSlice.actions;

export const selectChangePasswordModalIsOpen = (state) =>
  state.ChangePasswordModalSlice.isOpen;

export default ChangePasswordModalSlice.reducer;
